module.exports = "<main>\n\t<div id=\"app-loading\"></div>\n\t<router-outlet></router-outlet>\n</main>"